import React from 'react';

interface IProps {
  id: string;
  name: string;
  productsCount: number;
  isSelected: boolean;
  onChange: (id: string, isSelected: boolean) => void;
}

export default function Choice({ id, name, productsCount, isSelected, onChange }: IProps) {
  return (
    <label htmlFor={id} className="flex items-center gap-x-2 text-base laptop:text-sm">
      <input
        type="checkbox"
        id={id}
        name={id}
        onChange={checked => onChange(id, checked.target.checked)}
        defaultChecked={isSelected}
        disabled={productsCount === 0}
      />
      <div className="inline-flex items-baseline gap-x-2">
        <span>{name}</span>
        <span className="select-none text-sm laptop:text-xs">({productsCount})</span>
      </div>
    </label>
  );
}
